<template>
    <ul class="nav-menu">
        <template v-for="(item, id) in menuItems">
            <div v-if="id === 'sponsorship'" :key="`divider-${id}`" class="nav-menu__divider"></div>
            <!-- ID needed for notifications... -->
            <template v-if="id === 'notif' && hasNotification">
                <li :id="`headermenu_${id}`" :key="id" class="nav-menu__actions--item">
                    <Notifications />
                </li>
            </template>
            <template v-else>
                <CompassTooltip
                    :key="id"
                    :content="item.txt"
                    placement="bottom"
                    :delay="{ show: 1000, hide: 0 }"
                    :arrow="false"
                    :disabled="item.id === 'add'"
                    class="nav-item__actions"
                >
                    <li
                        :id="`headermenu_${id}`"
                        :key="id"
                        class="nav-menu__actions--item"
                        :class="{
                            'nav-item__actions--item-icon--animated': item.id === 'sponsorship',
                            'nav-menu__actions--item--no-hover': item.id === 'sellsyAcademy',
                        }"
                    >
                        <NavItem :item="item" />
                    </li>
                </CompassTooltip>
            </template>
        </template>
    </ul>
</template>

<script>
import NavItem from 'vcomponents/header/NavItem.vue';
import Notifications from 'vcomponents/header/Notifications.vue';

export default {
    name: 'NavMenu',
    components: {
        NavItem,
        Notifications,
    },
    props: {
        menuItems: {
            type: Object,
            required: true,
        },
        hasNotification: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.nav-menu {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    gap: var(--spacing-1);
    margin: 0;

    &__divider {
        width: 1px;
        height: var(--spacing-3);
        background-color: var(--colors-common-border-lighter);
        margin: 0 var(--spacing-1);
    }

    &__actions {
        &--item {
            position: relative;
            width: 28px;
            height: 28px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            border-radius: var(--spacing-0);
            cursor: pointer;
            &:hover:not(.nav-menu__actions--item--no-hover) {
                background-color: var(--colors-common-background-primary-subtle);
            }
        }
    }
}
</style>
